<script lang="ts" setup>
import UserStatus from "@/components/statuses/UserStatus.vue";
import LanguageTag from "@/components/statuses/LanguageTag.vue";
import PhoneNumber from "@/components/phones/PhoneNumber.vue";
import type { TruckDriverDto, TruckOwnerDto } from "@/api/trucks/dto/truck.dto";
import TruckContactPersonRoles from "@/views/fleets/components/TruckContactPersonRoles.vue";
import type { DriverDto } from "@/api/users/dto/driver.dto";
import type { OwnerDto } from "@/api/users/dto/owner.dto";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    member: TruckDriverDto | TruckOwnerDto | DriverDto | OwnerDto;
    hideStatus?: boolean;
    driverNameClass?: string;
    languageLight?: boolean;
    labelClass?: string;
  }>(),
  {
    hideStatus: false,
    driverNameClass: "",
    languageLight: false,
    labelClass: "bg-grey-lighten-4",
  },
);

const phone = computed(() => {
  if ("phone" in props.member) {
    return props.member.phone;
  } else if ("mobilePhone" in props.member) {
    return props.member.mobilePhone;
  } else {
    return "";
  }
});
</script>

<template>
  <div>
    <div :class="driverNameClass" class="d-flex align-center">
      <truck-contact-person-roles :contact-person="member" data-qa="truck-list-driver-role" />
      <span
        v-if="'contactPersonId' in member && member.id === member.contactPersonId"
        class="currency-icon mr-2 small"
      />
      <router-link
        :to="{ name: 'user-view', params: { id: member.id } }"
        class="text-primary text-decoration-none mr-2 line-height-1"
        data-qa="truck-driver-name"
        target="_blank"
      >
        {{ member.name }}
      </router-link>
      <user-status v-if="!hideStatus" :status="member.driverStatus" />
    </div>

    <div class="d-flex align-center">
      <phone-number
        v-if="phone"
        :number="phone"
        class="font-size-8 text-decoration-none text-primary"
        data-qa="truck-driver-phone"
      />
      <language-tag :language="member.language" :light="languageLight" class="ml-2"></language-tag>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
